var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-alert-container"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.user_alert.user_last_login_send},on:{"click":function($event){return _vm.SetAlertSettings()}}}),_c('p',[_vm._v("User Alert")])])
}
var staticRenderFns = []

export { render, staticRenderFns }